import { ChangeDetectionStrategy,Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatError, MatFormField, MatHint, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';

export interface AddStockPhotoSourceDialogResult {
    id: string;
    label: string | undefined;
}

@Component({
    templateUrl: './add-stock-photo-source-dialog.component.html',
    styleUrls: ['./add-stock-photo-source-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatDialogTitle, MatDialogContent, FormsModule, MatFormField, MatLabel, MatInput, MatError, MatHint, MatDialogActions, MatButton, MatDialogClose]
})
export class AddStockPhotoSourceDialogComponent {
    dialogRef = inject<MatDialogRef<AddStockPhotoSourceDialogComponent>>(MatDialogRef);

    stockPhotoSourceInfo: AddStockPhotoSourceDialogResult = {
        id: '',
        label: undefined
    };

    valid() {
        this.dialogRef.close(this.stockPhotoSourceInfo);
    }
}
